import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import PaymentForm from './PaymentForm.vue'
import WeddingGuestForm from './WeddingGuestForm.vue'
import EncryptedField from '@/components/EncryptedField.vue'

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(VueClipboard);

new Vue({
  render: h => h(PaymentForm),
}).$mount('#payment-form');

new Vue({
  render: h => h(WeddingGuestForm),
}).$mount('#wedding-guest-form');

document.querySelectorAll(".encrypted-field").forEach(element => {
  new Vue({
    render: h => h(EncryptedField, { props: { encryptedText: element.dataset.encryptedText }}),
  }).$mount(element);
});

